import React from 'react';
import type { Props } from '@peloton/flyout';
import Flyout from './Flyout';

const IntlFlyout: React.FC<React.PropsWithChildren<Props>> = ({
  ariaLabel,
  children,
  ...props
}) => (
  <Flyout ariaLabel={ariaLabel} {...props}>
    {children}
  </Flyout>
);

export default IntlFlyout;
